import { useAsgActions } from '../../../shared/src/hooks/use-asg-actions.hook';

export const HeaderService = {
    /**
     * @param verticals
     * @returns {*}
     */
    getDefaultVertical(verticals) {
        return verticals.find(v => v.isDefault) || verticals[0];
    },

    /**
     * @param verticals
     * @returns {*}
     */
    getVerticalsIds(verticals) {
        return verticals.map(v => v.id);
    },

    /**
     * Get similar items between two arrays of ids
     * @param ids1
     * @param ids2
     * @returns {*}
     */
    getIdsIntersection(ids1, ids2) {
        return ids1.filter(id => ids2.includes(id));
    },

    /**
     *
     * @param rootLink
     * @returns {boolean}
     */
    canRedirectByLocation(rootLink) {
        const { pathname } = window.location;
        return rootLink && (
            (rootLink !== pathname)
            || (rootLink === pathname && pathname === '/sport') // For the old solution.
        );
    },

    isMoreButtonVisible(firstPartVerticals, verticals) {
        return firstPartVerticals.length && firstPartVerticals.length !== verticals.length;
    },

    selectDefaultVertical({ verticals, rootLink, dispatch }) {
        const currentVertical = this.getDefaultVertical(verticals);
        const { setCurrentVerticalIdCookie, setCurrentVerticalCategorySet } = useAsgActions();

        dispatch(setCurrentVerticalIdCookie({
            verticalId: currentVertical.id,
            path: rootLink,
        }));
        dispatch(setCurrentVerticalCategorySet({
            path: rootLink,
            categoryId: currentVertical.categoryId,
            subCategoryId: currentVertical.subCategoryId,
        }));

        if (this.canRedirectByLocation(rootLink)) {
            const { goTo } = useAsgActions();
            dispatch(goTo(rootLink));
        } else {
            const { setCurrentVertical } = useAsgActions();
            dispatch(setCurrentVertical(currentVertical.id));
        }
    },

    goToLogoRegulationUrl(link, dispatch) {
        const { goTo } = useAsgActions();
        dispatch(goTo(link));
    },

    isLogoCenteredFromConfig(logoImageData) {
        return logoImageData.alignment === 'centered';
    },

    /**
     * @param verticals
     * @returns {boolean}
     */
    showVerticalsMenu(verticals) {
        return verticals.length > 1;
    },

    // Result could be different after 'statusBarRendered' event.
    getHeaderAndStatusBarHeight() {
        if (AsgApp.getIsOneOfNativeApps()) {
            return 0;
        }

        const headerOffset = document.querySelector('#asg-vertical-header').offsetHeight;
        const statusBarOffset = document.querySelector('#status-bar').offsetHeight;

        return headerOffset + statusBarOffset;
    },
};
